<script>
  import { Modal, ModalBody, ModalFooter, ModalHeader } from "sveltestrap";
  import { sectionVertical } from "../../../../js/constants";
  import { ICONS } from "../../../../js/icons";
  import GamePositionManager from "./GamePositionManager.svelte";
  export let showModalPositionGame;
  export let client = {};

  let selectedProvider = "";
  let selectedBrand = "";
  let selectedCategory = "";
  let inputSearch = "";
  let selectedOption = "";
  let selectedSection = sectionVertical.find(
    (section) => section.title === "Home"
  );
  let providers = [];
  let categories = [];
  let brands = [];

  const onShowPositionGame = () =>
    (showModalPositionGame = !showModalPositionGame);

  function selectSection(section) {
    selectedSection = section;
    selectedOption = "";
  }

  function selectOption(option) {
    selectedOption = option;
  }

  let appliedFilters = {
    vertical: "",
    section: "",
    search: "",
    provider: "",
    brand: "",
    category: "",
  };

  function searchGames() {
    appliedFilters = {
      vertical: selectedSection?.title,
      section: selectedOption,
      search: inputSearch,
      provider: selectedProvider,
      brand: selectedBrand,
      category: selectedCategory,
    };
  }

</script>

<Modal
  isOpen={showModalPositionGame}
  class="modal-fullscreen"
  toggle={onShowPositionGame}
>
  <ModalHeader toggle={onShowPositionGame}
    >Posición de Juegos: {client.namesite}
  </ModalHeader>
  <ModalBody>
    <div class="">
      <div class="sections">
        Verticales: 
        {#each sectionVertical as section}
          <button
            class="section-button"
            class:active={selectedSection?.id === section.id}
            on:click={() => selectSection(section)}
          >
            <img src={section.icon} alt="" class="section-icon"/>
            <span>{section.title}</span>
          </button>
        {/each}
      </div>
      {#if selectedSection}
        <div class="subsections">
          Etiquetas: 
          {#each selectedSection.options as option}
            <button
              class="subsection-button"
              class:active={selectedOption === option}
              on:click={() => selectOption(option)}
            >
              {option}
            </button>
          {/each}
        </div>
      {/if}
      <div class="filters-container">
        <div class="form-group">
          <span><b>Proveedor:</b></span>
          <select bind:value={selectedProvider}>
            <option value="">Todos</option>
            {#each providers as provider}
              <option value={provider.id}>{provider.name}</option>
            {/each}
          </select>
        </div>
        <div class="form-group">
          <span><b>Marca:</b></span>
          <select bind:value={selectedBrand}>
            <option value="">Todos</option>
            {#each brands as brand}
              <option value={brand.id}>{brand.name}</option>
            {/each}
          </select>
        </div>
        <div class="form-group">
          <span><b>Categoría:</b></span>
          <select bind:value={selectedCategory}>
            <option value="">Todos</option>
            {#each categories as category}
              <option value={category.id}>{category.name}</option>
            {/each}
          </select>
        </div>
        <div class="form-group">
          <span><b>Buscar:</b></span>
          <div style="display: flex; flex-direction:row; gap:0.5rem">
            <input
              type="text"
              bind:value={inputSearch}
              disabled={inputSearch !== ""}
            />
            <button
              class="btn search-btn btn-sm"
              title="Buscar"
              placeholder="Buscar"
              on:click={searchGames}>{@html ICONS.search}
            </button>
          </div>
        </div>
      </div>
      <GamePositionManager filters={appliedFilters} />
    </div>
  </ModalBody>
  <ModalFooter></ModalFooter>
</Modal>

<style>
  .sections {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 10px;
    margin-bottom: 20px;
    font-weight: bold;
  }

  .section-button {
    padding: 10px 16px;
    font-size: 14px;
    border: 1px solid #FF0090;
    border-radius: 9px;
    background: white;
    color: #FF0090;
    cursor: pointer;
  }

  .subsection-button {
    padding: 10px 16px;
    border: 1px solid #434343;
    border-radius: 9px;
    background: white;
    cursor: pointer;
  }

  .section-button.active {
    background: #FF0090;
    color: white;
  }

  .section-button.active .section-icon {
    filter: brightness(0) invert(1);
  }

  .subsections {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    font-weight: bold;
    gap: 10px;
    padding-top: 15px;
  }

  .subsection-button:hover {
    background: #f3f4f6;
  }

  .subsection-button.active {
    background: #0D6EFD;
    color: white;
    border-color: #0D6EFD;
  }

  .filters-container {
    display: grid;
    grid-template-columns: repeat(4, minmax(200px, 1fr));
    gap: 15px;
    margin-top: 20px;
  }
  
  .form-group {
    display: flex;
    flex-direction: column;
    gap: 5px;
  }
  
  .form-group select {
    padding: 10px;
    border: 1px solid #ced4da;
    border-radius: 6px;
    background-color: white;
  }

  .form-group input {
    width: 100%;
    padding: 7px;
    border: 1px solid #ced4da;
    border-radius: 6px;
    background-color: white;
  }

  .search-btn{
    background: #0D6EFD;
    color: white;
    border: none;
    padding: 0.5rem 1rem;
    margin-left: 0.5rem;
    border-radius: 5px;
    cursor: pointer;
  }
  
  .section-icon {
    width: 24px;
    height: 24px;
    object-fit: contain;
    vertical-align: middle;
    margin-right: 8px;
  }
  
  @media (max-width: 600px) {
    .filters-container {
      grid-template-columns: 1fr;
    }
  }
</style>
